import userSettings from "../user_settings"
import {loggedInUser} from "./helpers"
import routeRegex from "../route_regex"
import signals from "../signals"

const settings = userSettings.get("experiments") || {}

// when we run more than one experiment on the same page
// or even on different pages where we might want to check
// for interaction effects, then we want to create goals that
// show us not only their completion, but also which *other*
// experiment variant was picked.
//
// This method allows us to pass any number of experiments we
// want to tag this way
export function completeCrossExperimentGoal(experiments, goal) {
  for (const experiment of experiments) {
    // for every  *other* experiment in the list
    for (const otherExperiment of experiments) {
      if (otherExperiment.name !== experiment.name) {
        const otherName = otherExperiment.name
        const otherVariant = otherExperiment.getStoredVariant()
        const goalName = `${goal.name} [${otherName}=${otherVariant}]`
        // we complete a new goal in the format:
        // "goal [other_experiment={variant}]"
        experiment.goal_complete(goalName, goal.props)
      }
    }
  }
}

export function checkGoals() {
  const gb = window.gb
  if (window.gon.registeredWithProvider) {
    gb?.logEvent("registration success")
  }

  signals.on("kenhub.subscription_started", () => {
    gb?.logEvent("subscription started")
  })

  signals.on("kenhub.inlineQuizFinished", () => {
    gb?.logEvent("inline quiz finished")
  })

  signals.on("kenhub.subscription_started", () => {
    gb?.logEvent("subscription started")
  })

  if (window.location.pathname.match(routeRegex("/success-stories"))) {
    gb?.logEvent("success stories page viewed")
  }

  if (window.location.pathname.match(routeRegex("/search"))) {
    gb?.logEvent("search page viewed")
  }

  if (window.location.pathname.match(/pricing$/)) {
    gb?.logEvent("pricing page viewed")
    if (loggedInUser()) {
      gb?.logEvent("pricing page viewed by registered user")
    }
  }

  if (window.location.pathname.match(/checkout$/)) {
    gb?.logEvent("checkout page viewed")
  }

  if (
    window.location.pathname.match(/checkout$/) &&
    window.location.search.includes("plan=lifetime")
  ) {
    gb?.logEvent("lifetime checkout page viewed")
  }

  if (
    window.location.pathname.match(
      routeRegex("/(register|registration-ebook|registration-email)$")
    )
  ) {
    gb?.logEvent("registration page viewed")
  }

  signals.on("kenhub.new_web_session", () => {
    gb?.logEvent("new web session")
  })

  signals.on("kenhub.payment_initiated", ({type}) => {
    gb?.logEvent("payment initiated", {type})
  })

  signals.on("kenhub.quiz_started", () => {
    incrementQuizAccessed()
    gb?.logEvent("quiz started")
  })

  signals.on("kenhub.video_played", () => {
    incrementVideoAccessed()
    gb?.logEvent("video played")
  })

  signals.on("kenhub.custom_quiz_started", () => {
    gb?.logEvent("custom quiz started")
  })

  if (window.gon.tracking?.pageView === "article read") {
    incrementArticleAccessed()
  }

  if (window.gon.tracking?.pageView === "custom quiz page viewed") {
    gb?.logEvent("custom quiz viewed")
  }

  if (/\/study\//.test(window.location.pathname)) {
    gb?.logEvent("study unit viewed")
  }
}

function incrementVideoAccessed() {
  settings.videoAccessedCount = videoAccessedCount() + 1
  userSettings.register({experiments: settings})
  if (videoAccessedCount() >= 5) {
    window.gb?.logEvent("accessed 5+ videos")
  }
  if ((quizAccessedCount() + videoAccessedCount()) >= 5) {
    window.gb?.logEvent("accessed 5+ videos or quizzes")
  }
}

function incrementQuizAccessed() {
  settings.quizAccessedCount = quizAccessedCount() + 1
  userSettings.register({experiments: settings})
  if (quizAccessedCount() >= 5) {
    window.gb?.logEvent("accessed 5+ quizzes")
  }
  if ((quizAccessedCount() + videoAccessedCount()) >= 5) {
    window.gb?.logEvent("accessed 5+ videos or quizzes")
  }
}

function incrementArticleAccessed() {
  settings.articleAccessedCount = articleAccessedCount() + 1
  userSettings.register({experiments: settings})
  if (articleAccessedCount() >= 5) {
    window.gb?.logEvent("accessed 5+ articles")
  }
}

function videoAccessedCount() {
  return settings.videoAccessedCount || 0
}

function quizAccessedCount() {
  return settings.quizAccessedCount || 0
}

function articleAccessedCount() {
  return settings.articleAccessedCount || 0
}
